function Search() {
    ready(() => {
        const input = document.querySelector('#hero_search_form input');
        if (input) {
            input.addEventListener('typeahead:select', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const data = e.detail.args[0];
                if (typeof data.path !== 'undefined') {
                    location.href = data.path;
                }
            });
        }
    });
}

function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

module.exports = new Search();
